import { render, staticRenderFns } from "./PatentList.vue?vue&type=template&id=2e336f3c&scoped=true"
import script from "./PatentList.vue?vue&type=script&lang=js"
export * from "./PatentList.vue?vue&type=script&lang=js"
import style0 from "./PatentList.vue?vue&type=style&index=0&id=2e336f3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e336f3c",
  null
  
)

export default component.exports